import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'admin/status',
		component: Base,
		children: [
			{
				path: '',
				name: 'StatusList',
				component: List,
				meta: {
					path: '/admin/status',
					pai: 'Admin',
					title: 'siS - Status',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Status',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'StatusNovo',
				component: Form,
				meta: {
					path: '/admin/status',
					pai: 'Admin',
					title: 'siS - Status - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Status',
						class: '',
						active: false,
						url: '/admin/status'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'StatusEditar',
				component: Form,
				meta: {
					path: '/admin/status',
					pai: 'Admin',
					title: 'siS - Status - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Status',
						class: '',
						active: false,
						url: '/admin/status'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]